module.exports = __webpack_public_path__ + "static/media/20.021ffb73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/20.svg
// module id = 2812
// module chunks = 3